<section class="notification-item">
  <div class="notification-item__title">{{ data.title }}</div>
  <div class="notification-item__message" [innerText]="data.message"></div>
  <div class="notification-item__footer">
    <div>
      <div class="handshake" (click)="openWorkDoneConfirmation()" *ngIf="data.payload?.cause == 'JOB_COMPLETE'">
        <i class="fa-solid fa-handshake"></i>
      </div>
      <div class="whatsapp" (click)="openWhatsapp()" *ngIf="data.payload?.actionId == 'Yes'">
        <i class="fa-brands fa-whatsapp"></i>
      </div>
    </div>
    <small>
      {{ data.createdAt | date : "dd MMM hh:mm a" | uppercase }}
    </small>
  </div>
</section>
